import React, { useState } from "react";
import logo from "../assets/NHL_logo.png";
import avatar from "../assets/avatar.png";
import NotificationDropdown from "../components/NotificationDropdown";
import SubmissionReviewWindow from "../components/SubmissionReviewWindow";
import ProfileDropdown from "../components/ProfileDropdown";

function ExaminerSubmissions() {
  const [isReviewVisible, setReviewVisible] = useState(false);
  const [selectedSubmission, setSelectedSubmission] = useState(null);

  const [info, setInfo] = React.useState(null);
  const [submissions, setSubmissions] = React.useState([]);

  React.useEffect(() => {
    const getInfo = async () => {
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE}/profile`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer: ${localStorage.token}`,
            "ngrok-skip-browser-warning": "true",
          },
        }
      );

      if (!response.ok) {
        localStorage.removeItem("token");
        window.location.href = "/";
      }

      const parseRes = await response.json();

      if (parseRes?.isExaminer === false) {
        window.location.href = "/dashboard";
        return;
      }

      setInfo(parseRes);
    };
    getInfo();
  }, []);

  React.useEffect(() => {
    const getSubmissions = async () => {
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE}/submissions/details`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer: ${localStorage.token}`,
            "ngrok-skip-browser-warning": "true",
          },
        }
      );

      if (!response.ok) {
        localStorage.removeItem("token");
        window.location.href = "/";
      }

      let parseRes = await response.json();

      // exclude the submissions with the status "To be submitted"
      parseRes = parseRes.filter(
        (submission) => submission.status !== "To be submitted"
      );

      setSubmissions(parseRes);
    };
    getSubmissions();
  }, []);

  const openReview = (submission) => {
    setSelectedSubmission(submission);
    setReviewVisible(true);
  };

  const closeReview = () => {
    setSelectedSubmission(null);
    setReviewVisible(false);
  };

  const statusColours = (status) => {
    switch (status) {
      case "Pending review":
        return "bg-yellow-100 text-yellow-800";
      case "Reviwed":
        return "bg-green-100 text-green-800";
      default:
        return "bg-gray-100 text-gray-800";
    }
  };

  return (
    <div>
      <div className="min-h-screen flex">
        {/* Sidebar */}
        <aside className="w-64 bg-white border-r border-gray-200 fixed h-full">
          <div className="px-6 py-4 border-b border-gray-200">
            <img src={logo} alt="Logo" className="h-18" />
          </div>
          <nav className="mt-6 px-3">
            <a
              href="#"
              className="flex items-center px-3 py-2 text-sm font-medium rounded-md bg-black text-white mb-1"
            >
              <i className="fas fa-file-alt w-5 h-5 mr-2" />
              Submissions
            </a>
          </nav>
        </aside>

        {/* Main Content */}
        <div className="flex-1 ml-64">
          <header className="bg-white shadow-sm">
            <div className="max-w-8xl mx-auto px-4 sm:px-6 lg:px-8">
              <div className="flex justify-between h-16">
                <h1 className="text-xl font-semibold text-gray-900 flex items-center">
                  Submissions
                </h1>
                <div className="flex items-center">
                  <NotificationDropdown />
                  <div className="ml-4 flex items-center">
                    <img
                      className="h-8 w-8 rounded-full"
                      src={avatar}
                      alt="User"
                    />
                    <span className="ml-2 text-sm font-medium text-gray-700">
                      {info?.name}
                    </span>
                    <ProfileDropdown user={info} />
                  </div>
                </div>
              </div>
            </div>
          </header>
          <main className="max-w-8xl mx-auto py-6 sm:px-6 lg:px-8">
            <div className="bg-white shadow rounded-lg">
              <div className="px-6 py-6">
                <div className="flex justify-between items-center mb-6">
                  <h2 className="text-lg font-medium text-gray-900">
                    Recent Submissions
                  </h2>
                </div>
                <div className="space-y-4">
                  {submissions?.length > 0 ? (
                    submissions.map((submission) => (
                      <div
                        key={submission.id}
                        className="border rounded-lg p-4 hover:shadow-md transition-shadow cursor-pointer"
                        onClick={() => openReview(submission)}
                      >
                        <div className="flex justify-between items-start">
                          <div>
                            <h3 className="text-lg font-medium text-gray-900">
                              {submission.student_name},{" "}
                              {submission.company_name}
                            </h3>
                            <p className="text-sm text-gray-500">
                              {submission.course_name}
                            </p>
                            <p className="text-sm text-gray-500 mt-1">
                              Submitted: {submission.date}
                            </p>
                          </div>
                          <span
                            className={`px-3 py-1 text-sm font-medium rounded-full ${statusColours(
                              submission.status
                            )}`}
                          >
                            {submission.status}
                          </span>
                        </div>
                      </div>
                    ))
                  ) : (
                    <p className="text-gray-500 text-center">
                      No submissions found.
                    </p>
                  )}
                </div>
              </div>
            </div>
          </main>
        </div>
      </div>

      {/* Footer */}
      <footer className="bg-white border-t border-gray-200 fixed bottom-0 w-full">
        <div className="max-w-8xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="py-4 text-center text-sm text-gray-500">
            <p>© 2024 NHL Stenden. All rights reserved.</p>
          </div>
        </div>
      </footer>

      {/* Submission Review Window */}
      <SubmissionReviewWindow
        submissionDetails={selectedSubmission}
        isVisible={isReviewVisible}
        onClose={closeReview}
      />
    </div>
  );
}

export default ExaminerSubmissions;
